export const arrayToStringDelimiter = ', ';
export const stringToArrayDelimiter = /[,、] ?/g;
